<template>
  <app-modal class="finish-program-modal" @close="close">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get('Finish program')}}
      </template>

      <div class="text">
        {{$ml.get('After the program ends, you will not have access to edit it. But you can print a PDF report of this program at any time. Are you actually want to finish program?')}}
      </div>
      <div class="actions">
        <app-btn styling="inline" @click="close">
          {{$ml.get('Cancel')}}
        </app-btn>

        <app-btn
          :loading="loading"
          @click="finish"
        >
          {{$ml.get('Finish')}}
        </app-btn>
      </div>
    </app-modal-default>
  </app-modal>
</template>

<script>
import { ProgramAPI } from '@/api';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      loading: false,
    }
  },
  methods: {

    finish() {
      this.loading = true;
      return ProgramAPI.finish(this.program.id)
        .then(res => {
          this.program.finished = true;
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.$emit('close');
    }
  },

  computed: {
    ...mapGetters({
      program: 'program/data',
    }),
  },
}
</script>

<style lang="scss" scoped>

.finish-program-modal {
  .app-modal-default {
    max-width: 400px;
    width: 100%;
  }


  .text {
    line-height: 1.5;
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    padding-top: 20px;

    > * {
      margin-left: 20px;
    }
  }
}

</style>
